module.exports = __webpack_public_path__ + "files/fc8131381a4de3aad9957ee674e7e1d1.png";